
import React from "react";

interface IMenuIconProps {
  className?: string;
}

export const MenuIcon = ({
  className = "",
}: IMenuIconProps) => (
    <svg className="h-[12px] w-[12px] ml-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
);

export default MenuIcon;
